import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Image } from 'react-bootstrap';

import divider from '../images/about/kozmetikDivider.jpg';

import KozmetikLekeTedavisi from '../components/Kozmetik/KozmetikLekeTedavisi';
import CiltBakimi from '../components/Kozmetik/CiltBakimi';
import Peeling from '../components/Kozmetik/Peeling';
import Botox from '../components/Kozmetik/Botox';
import DolguUygulamalari from '../components/Kozmetik/DolguUygulamalari';
import Prp from '../components/Kozmetik/Prp';
import Mezoterapi from '../components/Kozmetik/Mezoterapi';
import Dermoroller from '../components/Kozmetik/Dermoroller';
import PdoIpleri from '../components/Kozmetik/PdoIpleri';
import KozmetikSideMenu from '../components/Kozmetik/KozmetikSideMenu';

import '../styles/about.css';

const KozmetikUygulamalar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeMenuItem, setActiveMenuItem] = useState('Leke Tedavisi');

  // URL'deki title parametresini oku ve aktif menü öğesini ayarla
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const titleFromURL = queryParams.get('title');
    if (titleFromURL) {
      setActiveMenuItem(decodeURIComponent(titleFromURL));
    }
  }, [location.search]);

  const handleMenuItemClick = (menuItem) => {
    setActiveMenuItem(menuItem);

    // URL'yi güncelle
    navigate(`/kozmetik-uygulamalar?title=${encodeURIComponent(menuItem)}`);

    // Sayfa üstüne kaydır
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const renderContent = () => {
    switch (activeMenuItem) {
      case 'Leke Tedavisi':
        return <KozmetikLekeTedavisi />;
      case 'Cilt Bakımı':
        return <CiltBakimi />;
      case 'Kimyasal Peeling':
        return <Peeling />;
      case 'Botox Uygulamaları':
        return <Botox />;
      case 'Dolgu Uygulamaları':
        return <DolguUygulamalari />;
      case 'PRP Uygulamaları':
        return <Prp />;
      case 'Mezoterapi Uygulamaları':
        return <Mezoterapi />;
      case 'Dermoroller Uygulamaları':
        return <Dermoroller />;
      case 'PDO İpleri ve Cilt Germe':
        return <PdoIpleri />;
      default:
        return null;
    }
  };

  return (
    <div className='about-page'>
      <Image src={divider} fluid className="about-img" />
      <Container>
        <Row className='mt-4'>
          {/* Büyük ekranlarda sol menü ve sağ içerik */}
          <Col lg={3} className='d-none d-lg-block'>
            <KozmetikSideMenu handleMenuItemClick={handleMenuItemClick} activeMenuItem={activeMenuItem} />
          </Col>
          <Col lg={9} className='d-none d-lg-block'>
            <div className="content">
              {renderContent()}
            </div>
          </Col>
          {/* Küçük ekranlarda içerik üstte, menü altta */}
          <Col xs={12} className='d-block d-lg-none'>
            <div className="content">
              {renderContent()}
            </div>
          </Col>
          <Col xs={12} className='d-block d-lg-none'>
            <KozmetikSideMenu handleMenuItemClick={handleMenuItemClick} activeMenuItem={activeMenuItem} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default KozmetikUygulamalar;
